import { Action, createReducer } from '@ngrx/store';

export interface SettingsState {
  // List of behaviour fields
  behaviour: string[];
}

const initialState = {
  behaviour: [
    'comb',
    'comb_building',
    'temper',
    'hygienic',
    'nosema',
    'broodnest',
    'propolis_prod',
    'pollen_collection',
  ],
} as SettingsState;

// No actions here yet - just initial state
const settingsReducer = createReducer<SettingsState>(initialState);

export function reducer(state: SettingsState | undefined, action: Action) {
  return settingsReducer(state, action);
}
